export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

//systems
export const LOAD_SYSTEMS_SUCCESS = 'LOAD_SYSTEMS_SUCCESS';
export const CREATE_SYSTEM_SUCCESS = 'CREATE_SYSTEM_SUCCESS';
export const UPDATE_SYSTEM_SUCCESS = 'UPDATE_SYSTEM_SUCCESS';
export const DELETE_SYSTEM_SUCCESS = 'DELETE_SYSTEM_SUCCESS';

//sites
export const LOAD_SITES_SUCCESS = 'LOAD_SITES_SUCCESS';
export const CREATE_SITE_SUCCESS = 'CREATE_SITE_SUCCESS';
export const UPDATE_SITE_SUCCESS = 'UPDATE_SITE_SUCCESS';
export const DELETE_SITE_SUCCESS = 'DELETE_SITE_SUCCESS';

//water readings
export const LOAD_WATER_READINGS_SUCCESS = 'LOAD_WATER_READINGS_SUCCESS';
export const CREATE_WATER_READING_SUCCESS = 'CREATE_WATER_READING_SUCCESS';
export const UPDATE_WATER_READING_SUCCESS = 'UPDATE_WATER_READING_SUCCESS';
export const DELETE_WATER_READING_SUCCESS = 'DELETE_WATER_READING_SUCCESS';

//wastewater readings
export const LOAD_WASTE_WATER_READINGS_SUCCESS =
  'LOAD_WASTE_WATER_READINGS_SUCCESS';
export const CREATE_WASTE_WATER_READING_SUCCESS =
  'CREATE_WASTE_WATER_READING_SUCCESS';
export const UPDATE_WASTE_WATER_READING_SUCCESS =
  'UPDATE_WASTE_WATER_READING_SUCCESS';
export const DELETE_WASTE_WATER_READING_SUCCESS =
  'DELETE_WASTE_WATER_READING_SUCCESS';

//daily logs
export const LOAD_DAILY_LOGS_SUCCESS = 'LOAD_DAILY_LOG_SUCCESS';
export const CREATE_DAILY_LOG_SUCCESS = 'CREATE_DAILY_LOG_SUCCESS';
export const LOAD_DAILY_LOG_ENTRIES_SUCCESS = 'LOAD_DAILY_LOG_ENTRIES_SUCCESS';
export const CREATE_DAILY_LOG_ENTRY_SUCCESS = 'CREATE_DAILY_LOG_ENTRY_SUCCESS';
export const UPDATE_DAILY_LOG_ENTRY_SUCCESS = 'UPDATE_DAILY_LOG_ENTRY_SUCCESS';
export const DELETE_DAILY_LOG_ENTRY_SUCCESS = 'DELETE_DAILY_LOG_ENTRY_SUCCESS';

//repair logs
export const LOAD_REPAIR_LOGS_SUCCESS = 'LOAD_REPAIR_LOGS_SUCCESS';
export const CREATE_REPAIR_LOG_SUCCESS = 'CREATE_REPAIR_LOG_SUCCESS';
export const LOAD_REPAIR_LOG_ENTRIES_SUCCESS =
  'LOAD_REPAIR_LOG_ENTRIES_SUCCESS';
export const CREATE_REPAIR_LOG_ENTRY_SUCCESS =
  'CREATE_REPAIR_LOG_ENTRY_SUCCESS';
export const UPDATE_REPAIR_LOG_ENTRY_SUCCESS =
  'UPDATE_REPAIR_LOG_ENTRY_SUCCESS';
export const DELETE_REPAIR_LOG_ENTRY_SUCCESS = 'DELETE_DAILY_LOG_ENTRY_SUCCESS';

export const UPLOAD_REPAIR_LOG_IMAGE_SUCCESS =
  'UPLOAD_REPAIR_LOG_IMAGE_SUCCESS';
export const DOWNLOAD_REPAIR_LOG_IMAGE_SUCCESS =
  'DOWNLOAD_REPAIR_LOG_IMAGE_SUCCESS';

//time cards
export const LOAD_TIME_CARDS_SUCCESS = 'LOAD_TIME_CARDS_SUCCESS';
export const CREATE_TIME_CARD_SUCCESS = 'CREATE_TIME_CARD_SUCCESS';
export const UPDATE_TIME_CARD_SUCCESS = 'UPDATE_TIME_CARD_SUCCESS';
export const DELETE_TIME_CARD_SUCCESS = 'DELETE_TIME_CARD_SUCCESS';
export const GENERATE_TIME_CARD_SUCCESS = 'GENERATE_TIME_CARD_SUCCESS';

//time entries
export const LOAD_TIME_CARD_ENTRIES_SUCCESS = 'LOAD_TIME_CARD_ENTRIES_SUCCESS';
export const CREATE_TIME_CARD_ENTRY_SUCCESS = 'CREATE_TIME_CARD_ENTRY_SUCCESS';
export const UPDATE_TIME_CARD_ENTRY_SUCCESS = 'UPDATE_TIME_CARD_ENTRY_SUCCESS';
export const DELETE_TIME_CARD_ENTRY_SUCCESS = 'DELETE_TIME_CARD_ENTRY_SUCCESS';

//pay periods
export const LOAD_PAY_PERIODS_SUCCESS = 'LOAD_PAY_PERIODS_SUCCESS';
export const CREATE_PAY_PERIOD_SUCCESS = 'CREATE_PAY_PERIOD_SUCCESS';
export const UPDATE_PAY_PERIOD_SUCCESS = 'UPDATE_PAY_PERIOD_SUCCESS';
export const DELETE_PAY_PERIOD_SUCCESS = 'DELETE_PAY_PERIOD_SUCCESS';

//pay period weeks
export const LOAD_PAY_PERIOD_WEEKS_SUCCESS = 'LOAD_PAY_PERIOD_WEEKS_SUCCESS';
export const CREATE_PAY_PERIOD_WEEK_SUCCESS = 'CREATE_PAY_PERIOD_WEEK_SUCCESS';
export const UPDATE_PAY_PERIOD_WEEK_SUCCESS = 'UPDATE_PAY_PERIOD_WEEK_SUCCESS';
export const DELETE_PAY_PERIOD_WEEK_SUCCESS = 'DELETE_PAY_PERIOD_WEEK_SUCCESS';

//users
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

//reports
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';

//pay cards
export const GENERATE_PAY_CARD_SUCCESS = 'GENERATE_PAY_CARD_SUCCESS';

//login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

//contact page
export const CONTACT_MESSAGE_SUCCESS = 'CONTACT_MESSAGE_SUCCESS';
export const CONTACT_MESSAGE_ERROR = 'CONTACT_MESSAGE_ERROR';

//user roles
export const LOAD_USER_ROLES_SUCCESS = 'LOAD_USER_ROLES_SUCCESS';
export const CREATE_USER_ROLE_SUCCESS = 'CREATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const DELETE_USER_ROLE_SUCCESS = 'DELETE_USER_ROLE_SUCCESS';

//billing items
export const LOAD_BILLING_ITEMS_SUCCESS = 'LOAD_ENTRY_BILLING_ITEMS_SUCCESS';
export const CREATE_BILLING_ITEM_SUCCESS = 'CREATE_BILLING_ITEM_SUCCESS';
export const UPDATE_BILLING_ITEM_SUCCESS = 'UPDATE_BILLING_ITEM_SUCCESS';
export const DELETE_BILLING_ITEM_SUCCESS = 'DELETE_BILLING_ITEM_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js